import { redirect } from "react-router-dom";

import { getNextOnboardingStepHref } from "@/modules/onboarding";

export default async function createAccountAction({ request }) {
  const formData = await request.formData();
  const name = formData.get("name");
  if (!name?.trim().length) {
    return { formErrors: { name: "Mandatory field" } };
  }

  const searchParams = new URL(request.url).searchParams;
  searchParams.set("name", formData.get("name"));
  return redirect(getNextOnboardingStepHref(searchParams));
}
